import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

type Item = {
  [key: string]: string;
};

type Base64Image = string;

type EquipamentoLogo = {
  [key: string]: string;
};
interface MenuItem {
  label: string;
  callback: (id: string) => void;
}

@Component({
  standalone: false,
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() content: string[];
  @Input() item: Item;
  @Input() cardImage: TemplateRef<any>;
  @Input() imageRaster: Base64Image;
  @Input() title: string;
  @Input() menuItems: Array<MenuItem>;
  @Input() backgroundImage: string | null;
  @Input() statusTranslationPrefix: string;
  @Input() status: string;
  @Input() openMenu = false;
  @Input() imagemPathEquipamento;
  @Input() cardNotificationGFreeTier: TemplateRef<any>;
  @Input() onCardClicked: ((callback: () => void) => void) | null;
  @Output() cardChanged = new EventEmitter();
  menuAtual = '';

  private clickListener: (event: MouseEvent) => void;

  constructor(
    private elementRef: ElementRef,
    private readonly translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.setupClickOutsideListener();
  }

  ngOnDestroy(): void {
    if (this.clickListener) {
      document.removeEventListener('click', this.clickListener);
    }
  }

  private setupClickOutsideListener(): void {
    this.clickListener = (event: MouseEvent) => {
      if (!this.elementRef.nativeElement.contains(event.target)) {
        if (this.openMenu) {
          this.openMenu = false;
          this.cardChanged.emit(this.id);
        }
      }
    };
    document.addEventListener('click', this.clickListener);
  }

  public getStatusClass(status: string): string {
    if (status === 'completed') {
      return 'cardTasks__content--info---description----statusSuccess';
    } else if (status === 'error') {
      return 'cardTasks__content--info---description----statusDanger';
    } else if (status === 'processing') {
      return 'cardTasks__content--info---description----statusWarning';
    } else if (status === 'emptyTask') {
      return 'cardTasks__content--info---description----statusInfo';
    } else {
      return '';
    }
  }

  onClickMenu(event: MouseEvent) {
    event.stopPropagation();
    if ((this.status === 'completed', 'error', 'processing')) {
      if (this.openMenu) {
        this.openMenu = false;
      } else {
        this.openMenu = true;
      }

      this.cardChanged.emit(this.id);
    }
  }

  disableButton(status: string): boolean {
    if (status === 'completed' && this.onCardClicked !== null) {
      return false;
    } else {
      return true;
    }
  }

  onCardClick() {
    if (this.status === 'completed') {
      this.onCardClicked(() => {});
    }
  }
}
